<!--  -->
<template>
  <div class="classification">
    <el-form ref="formTool" :inline="true" style="text-align: left">
      <div class="header">
        <section>
          <el-form-item>
            <el-select v-model="goodsType" style="width: 130px" size="small">
              <el-option label="自营商品" value="自营商品" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select size="small" @change="(val) => { goodsBaseChange(val); }" v-model="goodsBaseName" style="width: 130px">
              <el-option v-for="(item, index) in goodsBaseTypeList" :key="index" :label="item.name" :value="item" />
            </el-select>
          </el-form-item>
          <!-- <el-form-item>
            <el-select size="small" disabled v-model="orgName" style="width: 130px">
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select size="small" @change="chooseArea" v-model="areaName" style="width: 130px" clearable>
              <el-option v-for="(item, index) in areaList" :key="index" :label="item.orgName" :value="item" />
            </el-select>
          </el-form-item> -->
          <el-form-item  prop="radio" label="">
            <el-cascader 
            style="width: 150px;"
            ref="selectDom"
            v-model="orgSelect"
            :props="{ checkStrictly: true }"
            placeholder="请选择关联组织"
            size="mini"
            :options="selectData"
            @change="selectChange" />
          </el-form-item>
          <el-form-item prop="clinicName">
            <el-input style="width: 130px" v-model="customName" size="small" placeholder="客户名称" clearable/>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="query()" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="reset()" type="info">重置</el-button>
          </el-form-item>
        </section>
      </div>
    </el-form>
    <div class="tag-box">
      <span>
        <span style="font-weight: 600;color: #333;margin-right: 20px;">地区默认定价</span>
        <span>销售定价</span>
        <span class="price-view">¥{{ priceFixedTwo(deatilData.salePrice )}}</span>
        <span>元/{{ tableTagForm.goodsSkuUnit }}</span>
      </span>
      <span class="list">合作医药公司<span class="price-view">¥{{priceFixedTwo(deatilData.drugAmount)}}</span>元</span>
      <span class="list">地区公司<span class="price-view">¥{{priceFixedTwo(deatilData.areaAmount)}}</span>元</span>
      <span class="list">地区公司转省区公司服务费<span class="price-view">¥{{ priceFixedTwo(deatilData.provinceAmount) }}</span>元</span>
      <!-- <span class="list">省区公司向学术资金专用账户转款<span class="price-view">¥{{ '60.00'}}</span>元</span> -->
    </div>
    <div class="content-table">
      <ProvinceFixPriceTable 
        ref="self-price-table" 
        :unit-list="unitList" 
        :goodsName="goodsBaseName"
        :goodsId="goodsBaseId" 
        :orgCode="orgCode" 
        :orgName="orgName"
        :shopName="customName"
        @goodsSkuPrice="goodsSkuPriceList"
      ></ProvinceFixPriceTable>
    </div>
  </div>
</template>
  
<script>
import {
  goodsBaseType,
  getOrgProductLineSkuList
} from "@/api/saleRule/productLine";
import { deptTree } from '@/api/auditcenter'
import ProvinceFixPriceTable from './components/provinceFixPriceTable.vue'
export default {
  components: { ProvinceFixPriceTable },
  data() {
    return {
      goodsType: "自营商品",
      provinceName: "湖南省",
      areaList: [],
      orgName:'',
      orgCode:'',
      tableTagForm: {
        price: "",
        amount: "",
        city_amount: "",
        serviceAmount: "",
        goodsSkuUnit: "盒",
        amountZk: '60.00'
      },
      price: 0,

      tableData: [],
      unitList: [],

      page: {
        total: 0,
        current: 1,
        size: 20,
        pageSizes: [10, 20, 30, 50],
      },
      accountId: "",
      isAccount: false,
      dialogVisible: false,
      unitKey: 0,
      goodsBaseName: "",
      goodsBaseId: "",
      goodsBaseTypeList: [], //商品类型
      customName: "",
      fixPriceDialog: false,
      deatilData:{},
      orgSelect:null,
      selectData: []
    };
  },
  computed: {},
  watch: {},
  created() {
    this.goodsBaseType();
    this.getDeptTree();
  },
  mounted() { },
  beforeCreate() { },
  beforeMount() { },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  activated() { },
  methods: {
    goodsBaseChange(val) {
      this.goodsBaseId = val.goodsId;
      this.goodsBaseName = val.name;
    },
    getDeptTree () {
      deptTree().then(res => {
        if (res.code === 0) {
          this.selectData = this.treeReset(res.data)
        }
      })
    },
    treeReset (arrData) {
      let t = this;
      return arrData.map(li => {
        let d = {
          label: li.orgName,
          value: li.orgCode,
          code: li.orgCode
        }
        if (li.children && li.children.length > 0) {
          d.children = t.treeReset(li.children)
        }
        return d
      })
    },
    selectChange (val) {
      let checkEl = this.$refs['selectDom'].getCheckedNodes()
      if (checkEl && checkEl.length) {
        this.orgCode = checkEl[0].data.code
        this.orgName = checkEl[0].data.label
      }else{
        this.orgCode = ''
        this.orgName = ''
      }
      console.log(checkEl[0].data)
      console.log(val)
    },
  
    // 获取自营商品列表 // 自营商品type固定传1
    goodsBaseType() {
      goodsBaseType(1).then((res) => {
        console.log(res, "res");
        if (res) {
          this.goodsBaseTypeList = res;
          this.goodsBaseId = res[0].goodsId;
          this.goodsBaseName = res[0].name;
          
        }
      });
    },
    // 重置
    reset() {
      this.customName = ""
      this.query()
    },
    query() {
      if(!this.orgCode){
        this.$message.warning('请选择组织')
        return
      }
      let params = {
        goodsId: this.goodsBaseId,
        orgCode: this.orgCode,
        orgName: this.orgName,
        shopName : this.customName,
      };
      getOrgProductLineSkuList(params).then((res) => {
        console.log(res);
        this.$refs["self-price-table"].init(this.provinceCode);
        if (res && res.goodsSkuPrice) {
            this.deatilData = res
          }else{
            this.deatilData = {} 
          }
        }).catch((error)=>{
          this.$refs["self-price-table"].resetData();
          this.deatilData = {}
        });
    },
    goodsSkuPriceList(e){
      this.goodsSkuPrice = e
    },
    priceFixedTwo(price){
      if (price && price > 0 ) {
        return price.toFixed(2)
      }else{
        return '0.00'
      }
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";

.classification {
  padding: 0px;

  .header {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 15px !important;
    border-bottom: 1px solid #f5f5f5;

    .font {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      text-align: left;
      color: #262626;
    }

    .el-form-item {
      margin: 0px 8px 0px 0px !important;
    }
  }

  background: white;

  .center {
    margin-top: 16px;
    padding: 0 24px;
    height: calc(100% - 131px);
  }
}

.btn-warp {
  margin: 15px;
}

.content-table {
  padding: 10px 20px;
}

.tag-input {
  width: 100px;
}

.tag-box {
  padding: 10px;
  margin: 10px 15px;
  background: rgba(255, 255, 0, 0.246);
  line-height: 40px;
  border-radius: 5px;
  font-size: 14px;
  color: #666;

  .list {
    margin-left: 10px;
  }

  .price-view {
    background-color: #fafafa;
    padding: 5px 10px;
    border-radius: 4px;
    margin: 0px 10px;
  }
}

.unit-tag {
  cursor: pointer;
}

.content-box {
  margin: 10px;

  .unit {
    padding: 5px;
    border: solid 1px #eee;
    color: #333;
    border-radius: 5px;
    margin: 0 5px;
    line-height: 40px;
  }

  .unit:hover {
    background: rgb(255, 73, 73);
    color: #fff;
    cursor: pointer;
  }

  .active {
    background: rgb(255, 73, 73);
    color: #fff;
  }
}

.unit-box {
  display: flex;
}

.unit-s {
  margin: 5px;
  cursor: pointer;
  color: #000;
}
</style>
  